var cc_gp_approve_register;
cc_gp_approve_register = new function () {
  var defaults,
      self = this,
      redirectToHomePage,
      initializeCloseButtons,
      initializeOnLoadDialog;
  defaults = {
    onLoadDialogSelector: "div[data-show-dialog-on-load='true']",
    dialogTitleAttrName: "data-dialog-title",
    dialogContentAttrName: "data-dialog-content",
    closeDialogButtonSelector: "a[data-close-dialog-button='true']",
    homeUrl: "",
    windowIsLoaded: false
  };

  this.initialize = function (options) {
    self.options = $.extend({}, defaults, options);
    initializeCloseButtons();
    if (self.options.windowIsLoaded) initializeOnLoadDialog();else {
      $(window).on("load", function () {
        initializeOnLoadDialog();
      });
    }
  };

  initializeCloseButtons = function initializeCloseButtons() {
    $(self.options.closeDialogButtonSelector).each(function () {
      var dialogButton = $(this);
      var dialogContentSelector = dialogButton.attr(self.options.dialogContentAttrName);
      dialogButton.on("click", function () {
        $(dialogContentSelector).ccDialog("close");
      });
    });
  };

  initializeOnLoadDialog = function initializeOnLoadDialog() {
    $(self.options.onLoadDialogSelector).each(function () {
      var dialogTitle = $(this).attr(self.options.dialogTitleAttrName);
      $(this).ccDialog({
        title: dialogTitle,
        closeCallback: redirectToHomePage
      }).ccDialog("load");
    });
  };

  redirectToHomePage = function redirectToHomePage() {
    window.location.href = self.options.homeUrl;
  };
}();
var cc_gp_updateAccount;
cc_gp_updateAccount = new function () {
  var defaults,
      _this = this;

  defaults = {
    checkBoxSelector: "input[type='checkbox']",
    selectSelector: "select[data-pretty-select]",
    dialogButtonSelector: "a[data-dialog='true']",
    dialogTitleAttrName: "data-dialog-title",
    dialogContentAttrName: "data-dialog-content",
    dialogOkAttrName: "data-dialog-ok",
    dialogCancelAttrName: "data-dialog-cancel",
    closeDialogButtonSelector: "a[data-close-dialog-button='true']",
    termsAndConditionsCheckBoxSelector: "input[data-terms-and-conditions-checkox]",
    termsAndConditionsToggleButton: ".toggle-terms-and-conditions-button",
    termsAndConditionsToggleArea: ".toggle-terms-and-conditions",
    hiddenClassName: "hidden",
    continueButtonSelector: "#continue-button",
    splashContainerSelector: "#defaultSplash",
    splashTitle: "",
    closeModalDialogButton: "#close-modal-button"
  };

  this.initialize = function (options) {
    var $continueButton;
    _this.options = $.extend({}, defaults, options);
    $.resetFormValidation("form", "");

    if ($().ccCheckable) {
      $(_this.options.checkBoxSelector).ccCheckable();
    }

    if ($().selectBox) {
      $(_this.options.selectSelector).selectBox();
    }

    $(_this.options.splashContainerSelector).ccSplash({
      title: _this.options.splashTitle
    });

    _this.initializeDialogs();

    _this.initializeTermsConditionToggle();

    $(_this.options.closeModalDialogButton).on('keydown', function (event) {
      var keycode = event.keyCode ? event.keyCode : event.which;

      if (keycode == '13') {
        event.preventDefault();
        $(_this.options.closeModalDialogButton).click();
      }
    });
    $continueButton = $(_this.options.continueButtonSelector);
    $continueButton.on("click", function (event) {
      return _this.onContinueButtonClick(event);
    });
    $(_this.options.termsAndConditionsCheckBoxSelector).on("change", function (event) {
      var $termsAndConditionsCheckBox;
      $termsAndConditionsCheckBox = $(event.currentTarget);

      if ($termsAndConditionsCheckBox.is(":checked")) {
        $continueButton.removeClass("disabled");
      } else {
        $continueButton.addClass("disabled");
      }

      return null;
    });
    return false;
  };

  this.initializeDialogs = function () {
    $(_this.options.dialogButtonSelector).each(function (index, element) {
      var $dialogButton, $dialogContent, dialogContentSelector, dialogTitle;
      $dialogButton = $(element);
      dialogTitle = $dialogButton.attr(_this.options.dialogTitleAttrName);
      dialogContentSelector = $dialogButton.attr(_this.options.dialogContentAttrName);
      $dialogContent = $(dialogContentSelector);
      $dialogContent.ccDialog({
        title: dialogTitle
      });
      $dialogContent.find(_this.options.closeDialogButtonSelector).on("click", function () {
        return $dialogContent.ccDialog("close");
      });
      $dialogButton.on("click", function () {
        return $(dialogContentSelector).ccDialog("load");
      });
      return false;
    });
    return false;
  };

  this.initializeTermsConditionToggle = function () {
    $(_this.options.termsAndConditionsToggleButton).on("click", function () {
      $(_this.options.termsAndConditionsToggleArea).toggleClass(_this.options.hiddenClassName);
      return false;
    });
    return false;
  };

  this.onContinueButtonClick = function (event) {
    var $button, $form, formSelector;
    $button = $(event.currentTarget);

    if ($button.hasClass("disabled")) {
      return;
    }

    formSelector = $button.attr("data-submit-form-selector");
    $form = $(formSelector);
    $form.validate();

    if (!$form.valid()) {
      return;
    }

    $(_this.options.splashContainerSelector).ccSplash("load");
    $form.trigger("submit");
    return false;
  };

  return false;
}();
var cc_gp_registration_info_message;
cc_gp_registration_info_message = new function () {
  var defaults,
      _this = this;

  defaults = {
    onLoadDialogSelector: "div[data-show-dialog-on-load='true']",
    dialogTitleAttrName: "data-dialog-title",
    dialogContentAttrName: "data-dialog-content",
    dialogButtonOkAttrName: "data-dialog-ok",
    dialogTextAttrName: "data-dialog-text",
    watermarkTypeClass: "x-watermark-info",
    homeUrl: "",
    windowIsLoaded: false
  };

  this.initialize = function (options) {
    _this.options = $.extend({}, defaults, options);

    if (_this.options.windowIsLoaded) {
      _this.onWindowLoad(evt);
    } else {
      $(window).on("load", function (evt) {
        return _this.onWindowLoad(evt);
      });
    }
  };

  this.onWindowLoad = function (evt) {
    var funcRedirect, opt;
    opt = _this.options;
    funcRedirect = _this.redirectToHomePage;
    $(_this.options.onLoadDialogSelector).each(function (index, element) {
      var $elm,
          btnName,
          dialogTitle,
          message,
          _this = this;

      $elm = $(element);
      dialogTitle = $elm.attr(opt.dialogTitleAttrName);
      btnName = $elm.attr(opt.dialogButtonOkAttrName);
      message = $elm.attr(opt.dialogTextAttrName);
      $elm.ccConfirm({
        title: dialogTitle,
        textMessage: message,
        closeCallback: funcRedirect,
        watermarkTypeClass: opt.watermarkTypeClass,
        buttons: {
          "btnOk": {
            text: btnName,
            action: "accept",
            click: function click() {
              return funcRedirect();
            }
          }
        }
      }).ccConfirm("load");
    });
    return false;
  };

  this.redirectToHomePage = function () {
    window.location.href = _this.options.homeUrl;
    return false;
  };
}();
var cc_gp_register_confirm_continue;
cc_gp_register_confirm_continue = new function () {
  var defaults,
      _this = this;

  defaults = {
    submitBtnSelector: "a[data-action-dialog-button='accept']"
  };

  this.initialize = function (options) {
    _this.options = $.extend({}, defaults, options);
    $(_this.options.submitBtnSelector).on("click", function (evt) {
      return _this.onSubmitButtonClick(evt);
    });
  };

  this.onSubmitButtonClick = function (evt) {
    var $form;
    $form = $(evt.target).closest("form");
    $form.trigger("submit");
    return false;
  };
}();
var cc_gp_register_account;
cc_gp_register_account = new function () {
  var defaults,
      self = this,
      onDomainAdd,
      doDomainAdd,
      getAddSiteDialog,
      generateRowIndex,
      initializeDialogs,
      showAddSiteDialog,
      getTermOfUseDialog,
      openTermsAndConditions,
      closeTermsAndConditions,
      checkDomainAlreadyAdded,
      initializeSubmitButtons,
      initializeAddSiteDialog,
      initializeAllowedDomains,
      initializeTermsAndConditionsDialog,
      initializeTermsConditionToggle;
  defaults = {
    splashContainerId: "#defaultSplash",
    splashTitle: "",
    confirmContainerSelector: "#defaultConfirm",
    confirmEmailOverlayBodyClass: "overlay-body confirm-email-overlay-body",
    confirmEmailOverlayHeaderClass: "overlay-header confirm-email-overlay-header",
    checkBoxSelector: "input[type='checkbox']",
    selectSelector: "select[data-jchosen='true']",
    submitButtonSelector: "a[data-submit='true']",
    submitFormAttrName: "data-submit-form",
    dialogButtonSelector: "a[data-dialog='true']",
    dialogTitleAttrName: "data-dialog-title",
    dialogContentAttrName: "data-dialog-content",
    dialogOkAttrName: "data-dialog-ok",
    dialogCancelAttrName: "data-dialog-cancel",
    closeDialogButtonSelector: "a[data-close-dialog-button='true']",
    onLoadDialogSelector: "div[data-show-dialog-on-load='true']",
    termsAndConditionsDialogSelector: "#termsAndConditions",
    termsAndConditionsButton: "#terms-and-conditions",
    termsAndConditionsCheckBoxSelector: "",
    termsAndConditionsToggleButton: ".toggle-terms-and-conditions-button",
    termsAndConditionsToggleArea: ".toggle-terms-and-conditions",
    hiddenClassName: "hidden",
    addSiteDialogFormSelector: "#add-site-form",
    addSiteButton: "#add-site-button",
    addSiteDialogContainerSelector: "#add-site-dialog-container",
    addSiteInputSelector: "#add-site-name",
    allowedDomainsContainerSelector: "#allowed-domains-container",
    allowedDomainTemplateSelector: "#allowed-domain-template",
    dataIndexInputSelector: "input[data-index]",
    dataValueInputSelector: "input[data-value]",
    dataTextSelector: "div[data-text]",
    dataRemoveAttrName: "data-remove-id",
    dataIndexPlaceholder: "",
    countryDropdownSelector: "",
    stateControlSelector: "",
    stateContainerSelector: "#state-container",
    countryGetStatesUrlAttribute: "data-get-states-url",
    countryGetStatesCountryParamAttribute: "data-get-states-url-country-param",
    countryGetStatesStateParamAttribute: "data-get-states-url-state-param",
    manufacturerSelector: "#Company_PartnerType",
    manufacturerValue: "manufacturer",
    manufacturerHidden: ".hidden-for-manufacturer",
    manufacturerTermsAndUseUrl: "",
    retailersTermsOfUseUrl: "",
    printTermsOfUseSelector: ".print-terms-and-conditions",
    manufacturerContentSelector: ".manufacturer-content",
    termsOfUseDelimetrSelector: ".content-delimetr",
    retailerContentSelector: ".retailers-content",
    termsOfUseCCCheckableSelector: "#lb_Profile_IsAgreeToTermsAndConditions",
    dellAccountIdRequired: "[name$=DellAccountIdRequired]",
    companyNameInputSelector: "#Company_Name",
    invalidFieldMsgAttribute: "data-val-regex"
  };

  this.initialize = function (options) {
    $.resetFormValidation("form", options.termsAndConditionsCheckBoxSelector);
    self.options = $.extend({}, defaults, options);
    initializeSubmitButtons();
    initializeDialogs();
    initializeAllowedDomains();
    initializeTermsConditionToggle();
    $(self.options.countryDropdownSelector).on("change", function (evt) {
      return self.onCountryChange(evt);
    });
    $(self.options.stateControlSelector).on("change", "", function (evt) {
      return self.onStateChange(evt);
    });

    if (jQuery().ccCheckable) {
      $(self.options.checkBoxSelector).ccCheckable();
    }

    if (jQuery().chosen) {
      $(self.options.selectSelector).chosen({
        disable_search: true,
        width: '100%'
      });
    }

    $(self.options.splashContainerId).ccSplash({
      title: self.options.splashTitle
    });
    self.setManufacturerVisibility();
    $(self.options.manufacturerSelector).on("change", self.setManufacturerVisibility);
    this.initializeValidation();
  }; // TODO refactor element custom error message


  this.initializeValidation = function () {
    $.validator.setDefaults({
      onkeyup: false
    });
    $("#content form").validate();

    if ($(self.options.companyNameInputSelector).length > 0) {
      $.validator.addMethod("validcompanyname", function (value, element) {
        element.title = $(self.options.companyNameInputSelector).attr(self.options.invalidFieldMsgAttribute);
        return isNaN(value);
      });
      $(self.options.companyNameInputSelector).rules("add", "validcompanyname");
    }

    return false;
  };

  this.setManufacturerVisibility = function () {
    var $manufacturerSelector = $(self.options.manufacturerSelector),
        $termsOfUseCheckbox = $(self.options.termsAndConditionsCheckBoxSelector),
        $manufacturerHidden = $(self.options.manufacturerHidden),
        $manufacturerContent = $(self.options.manufacturerContentSelector),
        $retailerContent = $(self.options.retailerContentSelector),
        $printTermsOfUseBtn = $(self.options.printTermsOfUseSelector);

    if ($termsOfUseCheckbox.is(':checked')) {
      $(self.options.termsOfUseCCCheckableSelector).trigger("click");
    }

    if ($manufacturerSelector.val() == self.options.manufacturerValue) {
      $manufacturerHidden.hide();
      $manufacturerContent.show();
      $(self.options.termsOfUseDelimetrSelector).hide();
      $retailerContent.hide();
      $printTermsOfUseBtn.attr("onclick", "javascript:openPrintPreviewDialog('" + self.options.manufacturerTermsAndUseUrl + "');");
      $(self.options.dellAccountIdRequired).val("False");
    } else {
      $manufacturerHidden.show();
      $manufacturerContent.hide();
      $retailerContent.show();
      $printTermsOfUseBtn.attr("onclick", "javascript:openPrintPreviewDialog('" + self.options.retailersTermsOfUseUrl + "');");
      $(self.options.dellAccountIdRequired).val($(self.options.dellAccountIdRequired).attr("data-value"));
    }
  };

  this.submitFormWithLoading = function (formSelector) {
    if ($(self.options.companyNameInputSelector).length > 0) {
      $(self.options.companyNameInputSelector).val($(self.options.companyNameInputSelector).val().trim());
    }

    var submitForm = $(formSelector);
    submitForm.validate();

    if (submitForm.valid()) {
      $(self.options.splashContainerId).ccSplash("load");
      submitForm.trigger("submit");
    }
  };

  this.setDynamicControls = function () {
    initializeSubmitButtons();
    initializeDialogs();
  };

  this.onCountryChange = function () {
    var $country, $state, selectedCountry, countryParam, parameters, state, stateParam, statesWereEnumerated, url;
    $country = $(self.options.countryDropdownSelector);
    selectedCountry = $country.val();
    countryParam = $country.attr(self.options.countryGetStatesCountryParamAttribute);
    url = $country.attr(self.options.countryGetStatesUrlAttribute);
    $state = $(self.options.stateControlSelector);
    state = $state.val();
    stateParam = $country.attr(self.options.countryGetStatesStateParamAttribute);
    statesWereEnumerated = $state.is("select");
    parameters = {};
    parameters[countryParam] = selectedCountry;
    parameters[stateParam] = state;
    cc_gp_ajaxHelper.ajax("GET", url, parameters, function (data) {
      self.updateState(data, statesWereEnumerated);
    }, function () {}, true);
    return true;
  };

  this.onStateChange = function () {
    var $state = $(self.options.stateControlSelector);
    $("#content form").validate().element($state);
    return true;
  };

  this.updateState = function (data, statesWereEnumerated) {
    var $container, $html, $select, $state;
    $html = $(data.htmlData);
    $container = $(self.options.stateContainerSelector);
    if (jQuery().chosen) $container.find(self.options.selectSelector).chosen("destroy");
    $container.empty().append($html);
    $select = $html.find(self.options.selectSelector);

    if ($select.length > 0) {
      if (jQuery().chosen) $select.chosen({
        disable_search: true,
        width: '100%'
      });
      if (jQuery().bgiframe) $select.bgiframe();
    }

    $state = $(self.options.stateControlSelector);

    if (statesWereEnumerated) {
      $state.val("");
    }

    $("#content form").validate().element($state);
  };

  getTermOfUseDialog = function getTermOfUseDialog() {
    return $(self.options.termsAndConditionsDialogSelector);
  };

  getAddSiteDialog = function getAddSiteDialog() {
    return $(self.options.addSiteDialogFormSelector);
  };

  initializeSubmitButtons = function initializeSubmitButtons() {
    $(self.options.submitButtonSelector).each(function () {
      var actionForm = $(this).attr(self.options.submitFormAttrName);
      $(this).on("click", function () {
        self.submitFormWithLoading(actionForm);
      });
      $(window).keypress(function (event) {
        if (event.which === 13) {
          self.submitFormWithLoading(actionForm);
        }
      });
    });
  };

  initializeDialogs = function initializeDialogs() {
    initializeAddSiteDialog();
    initializeTermsAndConditionsDialog();
  };

  initializeTermsConditionToggle = function initializeTermsConditionToggle() {
    $(self.options.termsAndConditionsToggleButton).on("click", function () {
      $(self.options.termsAndConditionsToggleArea).toggleClass(self.options.hiddenClassName);
    });
  };

  initializeAllowedDomains = function initializeAllowedDomains() {
    var $allowedDomainsContainer;
    $allowedDomainsContainer = $(self.options.allowedDomainsContainerSelector);
    $allowedDomainsContainer.find("[" + self.options.dataRemoveAttrName + "]").on("click", function () {
      $("#" + $(this).attr(self.options.dataRemoveAttrName)).remove();
    });
  };

  initializeAddSiteDialog = function initializeAddSiteDialog() {
    var btnOkText, btnCancelText;
    var $addSiteDialogFormContainer = getAddSiteDialog();
    var $addSiteButton = $(self.options.addSiteButton);
    var $addSiteDialogContainer = $addSiteDialogFormContainer.find(self.options.addSiteDialogContainerSelector);
    var dialogTitle;
    btnOkText = $addSiteDialogContainer.attr(self.options.dialogOkAttrName);
    btnCancelText = $addSiteDialogContainer.attr(self.options.dialogCancelAttrName);
    dialogTitle = $addSiteDialogContainer.attr(self.options.dialogTitleAttrName);
    $addSiteDialogFormContainer.ccDialog({
      title: dialogTitle,
      buttons: {
        'btnOk': {
          text: btnOkText,
          action: "accept",
          click: function click() {
            onDomainAdd($addSiteDialogFormContainer);
          }
        },
        'btnCancel': {
          text: btnCancelText,
          action: "decline",
          click: function click() {
            $addSiteDialogFormContainer.ccDialog("close");
          }
        }
      }
    });
    $addSiteButton.on("click", showAddSiteDialog);
  };

  initializeTermsAndConditionsDialog = function initializeTermsAndConditionsDialog() {
    var $container = getTermOfUseDialog();
    var $termsAndConditionButton = $(self.options.termsAndConditionsButton);
    $container.ccDialog();
    $termsAndConditionButton.on("click", openTermsAndConditions);
    $container.find(self.options.closeDialogButtonSelector).on("click", closeTermsAndConditions);
  };

  openTermsAndConditions = function openTermsAndConditions() {
    var $termsAndConditionsContainer = getTermOfUseDialog();
    $termsAndConditionsContainer.ccDialog("load");
  };

  closeTermsAndConditions = function closeTermsAndConditions() {
    var $termsAndConditionsContainer = getTermOfUseDialog();
    $termsAndConditionsContainer.ccDialog("close");
  };

  showAddSiteDialog = function showAddSiteDialog() {
    var $addSiteDialogContainer = getAddSiteDialog();
    $addSiteDialogContainer.ccDialog("load");
  };

  onDomainAdd = function onDomainAdd(dialog) {
    var $input = $(self.options.addSiteInputSelector);

    if ($input.valid()) {
      $(dialog).ccDialog("close");
      doDomainAdd($input.val());
    }

    return false;
  };

  doDomainAdd = function doDomainAdd(domain) {
    var $allowedDomainsContainer, $allowedDomainTemplate, $newAllowedDomain;
    var $valueField, rowIndex, fieldId, valFieldName;

    if (!checkDomainAlreadyAdded(domain)) {
      $allowedDomainsContainer = $(self.options.allowedDomainsContainerSelector);
      $allowedDomainTemplate = $(self.options.allowedDomainTemplateSelector);
      $newAllowedDomain = $allowedDomainTemplate.clone();
      rowIndex = generateRowIndex();
      $newAllowedDomain.attr("id", rowIndex);
      $newAllowedDomain.find(self.options.dataIndexInputSelector).val(rowIndex);
      $newAllowedDomain.show();
      $valueField = $newAllowedDomain.find(self.options.dataValueInputSelector);
      fieldId = $valueField.attr("id").replace(self.options.dataIndexPlaceholder, rowIndex);
      $valueField.attr("id", fieldId);
      valFieldName = $valueField.attr("name").replace(self.options.dataIndexPlaceholder, rowIndex);
      $valueField.attr("name", valFieldName);
      $valueField.val(domain);
      $newAllowedDomain.find(self.options.dataTextSelector).text(domain);
      $newAllowedDomain.find("[" + self.options.dataRemoveAttrName + "]").attr(self.options.dataRemoveAttrName, rowIndex).on("click", function () {
        $newAllowedDomain.remove();
      });
      $allowedDomainsContainer.append($newAllowedDomain);
    }
  };

  checkDomainAlreadyAdded = function checkDomainAlreadyAdded(domain) {
    var $allowedDomainsContainer;
    var alreadyAdded = false;
    $allowedDomainsContainer = $(self.options.allowedDomainsContainerSelector);
    $allowedDomainsContainer.find(self.options.dataValueInputSelector).each(function () {
      if ($(this).val() == domain) {
        alreadyAdded = true;
      }
    });
    return alreadyAdded;
  };

  generateRowIndex = function generateRowIndex() {
    return "row" + ((1 + Math.random()) * 0x10000 | 0).toString(16);
  };
}();
var cc_gp_register_email_sent;
cc_gp_register_email_sent = new function () {
  var defaults,
      self = this;
  defaults = {
    splashContainerId: "#defaultSplash",
    splashTitle: "",
    confirmContainerSelector: "#defaultConfirm",
    confirmEmailOverlayBodyClass: "overlay-body confirm-email-overlay-body",
    confirmEmailOverlayHeaderClass: "overlay-header confirm-email-overlay-header"
  };

  this.initialize = function (options) {
    self.options = $.extend({}, defaults, options);
  };

  this.confirmEmailOnBodyVisible = function () {
    if ($("body").is(":visible")) {
      self.confirmEmail();
    } else {
      setTimeout(self.confirmEmailOnBodyVisible, 100);
    }
  };

  this.confirmEmail = function () {
    var confirmElement = $(self.options.confirmContainerSelector);
    confirmElement.ccConfirm({
      title: self.options.confirmTitle,
      textMessage: self.options.confirmText,
      overlayBodyClass: self.options.confirmEmailOverlayBodyClass,
      overlayHeaderClass: self.options.confirmEmailOverlayHeaderClass,
      buttons: {
        'btnOk': {
          text: self.options.btnText,
          action: "accept",
          click: function click() {
            confirmElement.ccConfirm('close');
          }
        }
      },
      closeCallback: function closeCallback() {
        window.location.href = self.options.homeUrl;
      },
      watermarkTypeClass: "x-watermark-info"
    }).ccConfirm("load");
  };
}();
var cc_gp_pre_register;
cc_gp_pre_register = new function () {
  var defaults,
      redirectToLogin,
      openDialogButton,
      closeDialogButton,
      initializeDialogs,
      initializeSubmitButtons,
      initializeSelectAccountDialog,
      self = this;
  defaults = {
    splashContainerId: "#defaultSplash",
    splashTitle: "",
    checkBoxSelector: "input[type='checkbox']",
    selectSelector: "select[data-pretty-select]",
    submitButtonSelector: "a[data-submit='true']",
    dialogButtonSelector: "a[data-dialog='true']",
    dialogTitleAttrName: "data-dialog-title",
    dialogContentAttrName: "data-dialog-content",
    closeDialogButtonSelector: ".close.overlay-header-close-button",
    onLoadDialogSelector: "div[data-show-dialog-on-load='true']",
    selectAccountDialogSelector: "#select-account",
    loginSiteUrl: ""
  };

  this.initialize = function (options) {
    $("form").removeAttr("novalidate");
    self.options = $.extend({}, defaults, options);
    initializeSubmitButtons();
    initializeDialogs();
    $(document).ready(function () {
      initializeSelectAccountDialog();
    });

    if (jQuery().ccCheckable) {
      $(self.options.checkBoxSelector).ccCheckable();
    }

    if (jQuery().selectBox) {
      $(self.options.selectSelector).selectBox();
    }
  };

  initializeSubmitButtons = function initializeSubmitButtons() {
    $(self.options.submitButtonSelector).each(function () {
      var submitButton = $(this);
      var actionForm = submitButton.closest("form");
      submitButton.on("click", function () {
        $(actionForm).trigger("submit");
      });
      $(actionForm).on("keydown", function (event) {
        if (event.which == 13) {
          submitButton.trigger("click");
        }
      });
    });
  };

  initializeDialogs = function initializeDialogs() {
    $(self.options.dialogButtonSelector).each(openDialogButton);
    $(self.options.closeDialogButtonSelector).each(closeDialogButton);
  };

  openDialogButton = function openDialogButton() {
    var dialogButton = $(this);
    var dialogTitle = dialogButton.attr(self.options.dialogTitleAttrName);
    var dialogContentSelector = dialogButton.attr(self.options.dialogContentAttrName);
    $(dialogContentSelector).ccDialog({
      title: dialogTitle
    });
    $(this).on("click", function () {
      $(dialogContentSelector).ccDialog("load");
    });
  };

  closeDialogButton = function closeDialogButton() {
    var dialogButton = $(this);
    var dialogContentSelector = dialogButton.attr(self.options.dialogContentAttrName);
    dialogButton.on("click", function () {
      $(dialogContentSelector).ccDialog("close");
    });
  };

  initializeSelectAccountDialog = function initializeSelectAccountDialog() {
    $(self.options.onLoadDialogSelector).each(function () {
      var dialogTitle = $(this).attr(self.options.dialogTitleAttrName);
      $(this).ccDialog({
        title: dialogTitle,
        closeCallback: redirectToLogin
      }).ccDialog("load");
    });
    $(self.options.closeDialogButtonSelector).focus();
  };

  redirectToLogin = function redirectToLogin() {
    window.location.href = self.options.loginSiteUrl;
  };
}();

function hideRecaptchaAlert() {
  $("#cc-recaptcha-alert").hide();
}

;

function onCaptchaLoadCallback() {
  $('#g-recaptcha-response').attr('aria-hidden', true);
  $('#g-recaptcha-response').attr('aria-label', 'do not use');
  $('#g-recaptcha-response').attr('aria-readonly', true);
}

function onCaptchaExpiredCallBack() {
  setTimeout(onCaptchaLoadCallback, 1000);
}

var cc_gp_form_submit_dialog;
cc_gp_form_submit_dialog = new function () {
  var self = this;
  var o;
  var c = {
    attr: {
      targetAction: 'data-post-action',
      targetPostForm: 'data-post-target',
      successText: 'data-success-text',
      errorText: 'data-error-text',
      confirm: {
        ok: "data-dialog-ok"
      }
    },
    selector: {
      dialog: 'div[data-form-submit-dialog]',
      title: 'div[data-form-submit-dialog-label]',
      submitButton: 'button[data-form-submit-dialog-submit]',
      input: 'input',
      confirm: "#confirm-dialog",
      validationSummary: "div[data-valmsg-summary]"
    }
  };
  var defaults = {};

  this.initialize = function (options) {
    o = $.extend({}, defaults, options);
    $(document.body).on("keypress", c.selector.dialog + ' ' + c.selector.input, onInputKeyPressed);
    $(document).on("click", c.selector.submitButton, function (event) {
      var $elm = $(event.currentTarget);
      var $dialog = $elm.closest(c.selector.dialog);
      var $input = $dialog.find(c.selector.input);
      var $form = $input.closest("form");

      if (!$form.length) {
        return false;
      }

      var validator = $form.validate();

      if (!validator.form()) {
        return false;
      }

      var data = $form.serializeArray();
      submit($elm.attr(c.attr.targetAction), data, $dialog);
    });
    $("#Password_ConfirmPassword").rules("add", {
      equalTo: "#Password_Password"
    });
    addScreenReaderAttributes();
  };

  function addScreenReaderAttributes() {
    $(c.selector.validationSummary).attr("role", "alert");
    $(c.selector.validationSummary).attr("aria-live", "assertive");
  }

  function clearValidation($form) {
    $.validator.unobtrusive.parse($form);
    var validator = $form.validate();
    validator.resetForm();
    $form.find(".field-validation-error").empty();
    $form.find('.form-group').removeClass('has-error');
  }

  ;

  function submit(actionUrl, data, $dialog) {
    cc_gp_loading_service.showLoading();
    cc_gp_ajaxHelper.ajax('POST', actionUrl, data, function (obj) {
      cc_gp_loading_service.hideLoading();
      $dialog.modal('hide'); // notify success

      var title = $dialog.find(c.selector.title).text();
      notifySuccess(title, obj.successMessage);
    }, function (error) {
      cc_gp_loading_service.hideLoading();

      if (error.clientMessage) {
        displayError(error.clientMessage, $dialog);
      }
    }, true);
  }

  function notifySuccess(title, successMessage) {
    var $div = $(c.selector.confirm);
    var message = successMessage;
    var okButton = $div.attr(c.attr.confirm.ok);
    var myButtons = {};
    myButtons[okButton] = {
      action: 'accept',
      click: function click() {
        $div.ccConfirm("close");
      }
    };
    $div.ccConfirm({
      title: title,
      textMessage: message,
      buttons: myButtons
    }).ccConfirm("load");
  }

  ;

  function displayError(errorMessage, $dialog) {
    if (!$dialog) {
      return;
    }

    var $input = $dialog.find(c.selector.input);
    var $form = $input.closest("form");

    if (!$form.length) {
      return false;
    }

    $form.find("span.field-validation-valid, span.field-validation-error").html($("<span></span>").html(errorMessage)).addClass("field-validation-error").removeClass("field-validation-valid").show();
    $form.find('.form-group').addClass('has-error');
  }

  ;

  function onInputKeyPressed(event) {
    if (event.keyCode === 13) {
      var $dialog = $(event.currentTarget).closest(c.selector.dialog);
      var $submitButton = $dialog.find(c.selector.submitButton);
      $submitButton.trigger("click");
      return false;
    }
  }

  return this;
}();